/**
 * Ошибка HTTP-запроса к API с сохранённым кодом ответа.
 *
 * Нужна, чтобы UI мог отличить «сессия истекла» (401/403) от прочих ошибок
 * и показать пользователю внятную причину вместо общего «не получилось».
 */
export class ApiError extends Error {
    constructor(public readonly status: number, message?: string) {
        super(message ?? `HTTP ${status}`);
        this.name = "ApiError";
    }

    /** true, если проблема в авторизации (нет/просрочена сессия). */
    public get isAuth(): boolean {
        return this.status === 401 || this.status === 403;
    }
}
